/* possoftware/types */
import * as t from "io-ts";

function tOptional<T extends t.Mixed>(typeThing: T) {
  return t.union([t.undefined, t.null, typeThing]);
}
const tId = t.union([t.undefined, t.null, t.string]);

const ErrorCodec = t.type(
  {
    code: t.string,
    detail: t.string,
    title: t.string,
  },
  "ErrorCodec"
);
const AttributeCodec = t.intersection([
  t.type({
    ProviderIdentification: t.string,
    ApplicationName: t.string,
    SoftwareVersion: t.array(t.string),
    CertificationCode: t.string,
    KEK: tOptional(t.string),
    KEKIdentifier: tOptional(t.string),
    KEKVersion: tOptional(t.string),
  }),
  t.partial({}),
]);

export const DataCodec = t.intersection([
  t.type({
    id: tId,
    type: t.string,
    attributes: AttributeCodec,
  }),
  t.partial({
    createdAt: t.string,
    updatedAt: t.string,
  }),
]);

export type Data = t.TypeOf<typeof DataCodec>;

export const PosSoftwareCodec = t.type(
  {
    errors: tOptional(t.union([t.undefined, t.array(ErrorCodec)])),
    data: tOptional(t.array(DataCodec)),
  },
  "PosSoftwareCodec"
);

export type PosSoftware = t.TypeOf<typeof PosSoftwareCodec>;

export enum PosSoftwareActionTypes {
  FETCH = "@@posSoftware/FETCH",
  FETCH_SUCCESS = "@@posSoftware/FETCH_SUCCESS",
  FETCH_ERROR = "@@posSoftware/FETCH_ERROR",
  SAVE_REQUEST = "@@posSoftware/SAVE_REQUEST",
  SAVE_SUCCESS = "@@posSoftware/SAVE_SUCCESS",
  SAVE_ERROR = "@@posSoftware/SAVE_ERROR",
  DELETE_REQUEST = "@@posSoftware/DELETE_REQUEST",
  DELETE_SUCCESS = "@@posSoftware/DELETE_SUCCESS",
  DELETE_ERROR = "@@posSoftware/DELETE_ERROR",
}

export interface PosSoftwareState {
  readonly loading: boolean;
  readonly data: PosSoftware | undefined;
  readonly errors?: string;
}
